export interface BoardRef {
  id: string;
  slug: string;
}

export type PostLoginTarget =
  | { kind: "redirect"; path: string }
  | { kind: "display"; slug: string }
  | { kind: "dashboard"; clearInvalidPreferred: boolean };

/**
 * N'autorise que des destinations internes relatives à la SPA.
 * Rejette les URL absolues et les protocoles externes.
 */
export function sanitizeInternalRedirect(input?: string | null): string | null {
  if (!input) return null;

  const raw = input.trim();
  if (!raw) return null;
  if (!raw.startsWith("/")) return null;
  if (raw.startsWith("//")) return null;

  // Le route guard peut inclure le basepath /app dans certains contextes.
  const normalized = raw === "/app" ? "/" : raw.startsWith("/app/") ? raw.slice(4) : raw;
  if (!normalized.startsWith("/")) return null;

  return normalized;
}

export function resolvePostLoginTarget(input: {
  explicitRedirect: string | null;
  preferredBoardId: string | null;
  boards: BoardRef[];
}): PostLoginTarget {
  if (input.explicitRedirect) {
    return { kind: "redirect", path: input.explicitRedirect };
  }

  const preferred = (input.preferredBoardId ?? "").trim();
  if (!preferred) {
    return { kind: "dashboard", clearInvalidPreferred: false };
  }

  const board = input.boards.find((item) => item.id === preferred);
  if (!board) {
    return { kind: "dashboard", clearInvalidPreferred: true };
  }

  return { kind: "display", slug: board.slug };
}

export function toAppHref(path: string): string {
  if (path === "/") return "/app";
  return `/app${path}`;
}
